import { v4 as uuidv4 } from 'uuid';

export const randomUUID = () => uuidv4().toUpperCase();
